import { ExpenseDescription } from "@/types/expenseDescription";
import { Space, Switch, Tooltip } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { ColumnsProps } from "@/components/table";
import { ColumnsType } from "antd/es/table";

type GetColumnsProps = ColumnsProps<ExpenseDescription> & {
  onToggleActive?: (id: string, isActive: boolean) => void;
  onToggleReview?: (id: string, inReview: boolean) => void;
};

export const getColumns = ({
  onEdit,
  onToggleActive,
  onToggleReview,
  filterOptions,
  filterValues,
  getSortOrder,
}: GetColumnsProps): ColumnsType<ExpenseDescription> => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    sortOrder: getSortOrder?.("name"),
    filters: filterOptions?.name,
    filterSearch: true,
    filteredValue: filterValues?.name || null,
  },
  {
    title: "Expense Type",
    dataIndex: ["expense_type", "name"],
    key: "expense_type_id",
    sorter: true,
    sortOrder: getSortOrder?.("expense_type.name"),
    filters: filterOptions?.expense_type_id,
    filterSearch: true,
    filteredValue: filterValues?.expense_type_id || null,
    render: (name: string) => name || "-",
  },
  {
    title: "Unit",
    dataIndex: ["unit", "name"],
    key: "unit_id",
    sorter: true,
    sortOrder: getSortOrder?.("unit.name"),
    filters: filterOptions?.unit_id,
    filterSearch: true,
    filteredValue: filterValues?.unit_id || null,
    render: (name: string) => name || "-",
  },
  {
    title: "Active",
    dataIndex: "is_active",
    key: "is_active",
    sorter: true,
    sortOrder: getSortOrder?.("is_active"),
    render: (isActive: boolean, record: ExpenseDescription) => (
      <Switch
        checked={isActive}
        onChange={(checked) => onToggleActive?.(record.id, checked)}
      />
    ),
  },
  {
    title: "Reviewed",
    dataIndex: "is_reviewed",
    key: "is_reviewed",
    sorter: true,
    sortOrder: getSortOrder?.("is_reviewed"),
    render: (isReviewed: boolean, record: ExpenseDescription) => (
      <Switch
        checked={isReviewed}
        onChange={(checked) => onToggleReview?.(record.id, checked)}
      />
    ),
  },
  {
    title: "Actions",
    key: "actions",
    width: 100,
    render: (_: any, record: ExpenseDescription) => (
      <Space size="small">
        <Tooltip title="Edit">
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => onEdit?.(record)}
            size="small"
          />
        </Tooltip>
      </Space>
    ),
  },
];
